import { render, staticRenderFns } from "./ques1.vue?vue&type=template&id=37d2869a"
import script from "./ques1.vue?vue&type=script&lang=js"
export * from "./ques1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports